// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Purchase success page */

.BuyNowSucess_card__wNqHq {
  width: 100%;
  max-width: 560px;
  align-self: center;
  align-items: center;
  text-align: center;
}

.BuyNowSucess_successCircle__Q8uCq {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: var(--radius-full);
  background: var(--surface-success);
  color: var(--success);
}

.BuyNowSucess_copy__R7jQJ {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  max-width: 52ch;
}

.BuyNowSucess_sub__-l\\+bO {
  font-size: 0.875rem;
  line-height: 1.5;
  color: var(--text-secondary);
}

.BuyNowSucess_summary__FcL4F {
  width: 100%;
  box-sizing: border-box;
  padding: var(--space-4);
  border-radius: var(--radius-md);
  background: var(--bg-tertiary);
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.BuyNowSucess_row__i2MdN {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: baseline;
  gap: var(--space-1) var(--space-4);
}

.BuyNowSucess_rowLabel__NRvte {
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.5;
  color: var(--text-secondary);
}

.BuyNowSucess_orderId__7HtiJ {
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 0.875rem;
  line-height: 1.5;
  color: var(--text-primary);
  overflow-wrap: anywhere;
  min-width: 0;
}

.BuyNowSucess_actions__jJIs3 {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-2);
}

.BuyNowSucess_live__IlrLV {
  margin: 0;
  font-size: 0.875rem;
  color: var(--text-secondary);
}

.BuyNowSucess_live__IlrLV:empty {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/BuyNowSucess.module.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,qEAAqE;EACrE,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf","sourcesContent":["/* Purchase success page */\n\n.card {\n  width: 100%;\n  max-width: 560px;\n  align-self: center;\n  align-items: center;\n  text-align: center;\n}\n\n.successCircle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 64px;\n  height: 64px;\n  border-radius: var(--radius-full);\n  background: var(--surface-success);\n  color: var(--success);\n}\n\n.copy {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n  max-width: 52ch;\n}\n\n.sub {\n  font-size: 0.875rem;\n  line-height: 1.5;\n  color: var(--text-secondary);\n}\n\n.summary {\n  width: 100%;\n  box-sizing: border-box;\n  padding: var(--space-4);\n  border-radius: var(--radius-md);\n  background: var(--bg-tertiary);\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n}\n\n.row {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: var(--space-1) var(--space-4);\n}\n\n.rowLabel {\n  font-size: 0.875rem;\n  font-weight: 600;\n  line-height: 1.5;\n  color: var(--text-secondary);\n}\n\n.orderId {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  color: var(--text-primary);\n  overflow-wrap: anywhere;\n  min-width: 0;\n}\n\n.actions {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--space-2);\n}\n\n.live {\n  margin: 0;\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n}\n\n.live:empty {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `BuyNowSucess_card__wNqHq`,
	"successCircle": `BuyNowSucess_successCircle__Q8uCq`,
	"copy": `BuyNowSucess_copy__R7jQJ`,
	"sub": `BuyNowSucess_sub__-l+bO`,
	"summary": `BuyNowSucess_summary__FcL4F`,
	"row": `BuyNowSucess_row__i2MdN`,
	"rowLabel": `BuyNowSucess_rowLabel__NRvte`,
	"orderId": `BuyNowSucess_orderId__7HtiJ`,
	"actions": `BuyNowSucess_actions__jJIs3`,
	"live": `BuyNowSucess_live__IlrLV`
};
export default ___CSS_LOADER_EXPORT___;
